var MAX_IMAGES = 18

window.$ = window.jQuery

import './static/swiper.js'
import './static/jquery.touchSwipe.min.js'
//import '../vendor/ownbit/wp-module-slider/js/jquery.finger.min.js'
//import '../vendor/ownbit/wp-module-slider/js/jquery.OBSlider.min.js'
//import './static/jquery.GroupedImageGallery.js'

import './modules/jquery.Menu.js'
import './modules/jquery.Accordion.js'

$(function () {
  $('header.main').Menu({
    toggleClass: 'toggled',
    toggleContainer: '.toggle-container',
    toggleButton: '.toggle-button',
    closeButton: '.close-button'
  })

  /*
   * Init footer widget toggling.
   * Exclude specific widgets like image widgets.
   */
  import('./static/jquery.FooterWidgetFolder.js').then(module => {
    $('footer .widget').FooterWidgetFolder({
      excludeWidgets: ['OBImageWidget']
    })
  })

  /*
   * Init GroupedImageGalleries
   */
  if (jQuery.fn.GroupedImageGallery) {
    $('.gallery').GroupedImageGallery({})
  }

  /**
   * Limit number of Instagram images
   */
  var container = document.getElementById('sbi_images')
  if (!container) return

  var $loader = $('#sbi_load')
  var observer = new MutationObserver(function () {
    if (container.children.length >= MAX_IMAGES) {
      $loader.slideUp()
      observer.disconnect()
    }
  })
  observer.observe(container, {childList: true})
})
